import { Box, Chip } from "@mui/material";
import { Tooltip } from "@mui/material";
import {
    ADMIN_TYPES,
    BOOST_CATEGORIES,
    STATE_COLOR,
    TIER_TYPES
} from '../../constans/parameter';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export const adminListColumns = () => [
    // { field: 'id', headerName: "Id", flex: 1 },
    { field: 'email', headerName: "Email", flex: 1 },
    {
        field: 'role', headerName: "Rol", flex: 1, renderCell: (params) => {
            const match = ADMIN_TYPES.find((admin) => admin.Code === params.value);
            return match ? match.ValueText1 : params.value;
        }
    },
    // {
    //   field: 'CreatedAt', headerName: "Oluşturulma Tarihi", flex: 1,
    //   valueFormatter: (params) => dayjs(params.value).format('DD-MM-YYYY HH:mm')
    // },
];

export const ticketListColumns = () => [
    // { field: 'id', headerName: 'ID', width: 80 },
    // { field: 'ticket_id', headerName: 'Ticket ID', width: 110 },
    // { field: 'assignment_id', headerName: 'Assignment ID', width: 140 },

    { field: 'user_email', headerName: 'Email', flex: 1, minWidth: 200 },
    {
        field: 'category_code', headerName: 'Boost Kategorisi', width: 150, renderCell: (params) => {
            const match = BOOST_CATEGORIES.find((value) => value.Code === params.value);
            return match ? match.ValueText1 : params.value;
        }
    },

    { field: 'bucket', headerName: 'Boost Tipi', width: 120 },

    {
        field: 'requested_qty',
        headerName: 'İstenen Miktar',
        type: 'number',
        width: 140,
        align: 'left',
        headerAlign: 'left',
        renderCell: (params) => (
            <Box sx={{ width: '100%', textAlign: 'left' }}>
                {params.value ?? ''}
            </Box>
        ),
    },

    {
        field: 'user_note',
        headerName: 'Kullanıcı Notu',
        flex: 1.2,
        minWidth: 220,
        renderCell: (params) => {
            const text = params.value ?? '';
            return (
                <Tooltip title={text}>
                    <Box sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                    }}>
                        {text}
                    </Box>
                </Tooltip>
            );
        },
    },
    {
        field: 'created_at',
        headerName: 'Oluşturma Tarihi',
        flex: 1,
        minWidth: 170,
        renderCell: (params) => {
            const raw =
                params.row?.created_at ??
                params.row?.createdAt ??
                null;

            if (!raw) return '';
            return dayjs.utc(raw).local().format('DD-MM-YYYY HH:mm');
        },
        sortable: false,

    },
    {
        field: 'last_message_at',
        headerName: 'Son Mesaj Tarihi',
        flex: 1,
        minWidth: 170,
        renderCell: (params) => {
            const raw =
                params.row?.last_message_at ??
                params.row?.lastMessageAt ??
                null;

            if (!raw) return '';
            return dayjs.utc(raw).local().format('DD-MM-YYYY HH:mm');
        },
        sortable: false,
    },
    {
        field: 'state',
        headerName: 'Durum',
        width: 120,
        renderCell: (params) => (
            <Chip
                size="small"
                label={String(params.value || '').toUpperCase()}
                color={STATE_COLOR[params.value] || 'default'}
                variant="outlined"
            />
        ),
        sortable: true,
    },
];

export const userListColumns = () => [
    // { field: 'id', headerName: "Id", flex: 1 },
    { field: 'email', headerName: "Email", flex: 1 },
    { field: 'admin_email', headerName: "Admin Email", flex: 1 },
    {
        field: 'tier_id', headerName: "Kullanıcı Kategorisi", flex: 1, renderCell: (params) => {
            const match = TIER_TYPES.find((admin) => admin.Code === params.value);
            return match ? match.ValueText1 : params.value;
        }
    },
    { field: 'meta_id', headerName: 'Meta ID', flex: 1 },
    { field: 'score', headerName: "Puan", flex: 1 },
    {
        field: 'created_at', headerName: "Oluşturulma Tarihi", flex: 1,
        renderCell: (params) => {
            const raw =
                params.row?.created_at ??
                null;

            if (!raw) return '';
            return dayjs.utc(raw).local().format('DD-MM-YYYY HH:mm');
        },
    },
];

export const userBoostsAssignmentsListColumns = () => [
    // { field: 'id', headerName: "ID", flex: 1 },
    // { field: 'source_rule_id', headerName: "Rule ID", flex: 1 },
    { field: 'category_name', headerName: "Boost Kategorisi", flex: 1 },
    { field: 'bucket', headerName: "Boost Tipi", flex: 1 },
    { field: 'quantity', headerName: "Miktar", flex: 1 },
    { field: 'qty_used', headerName: "Kullanılan Miktar", flex: 1 },
    { field: 'value', headerName: "Değer", flex: 1 },
    // {
    //   field: 'expired',
    //   headerName: "Süresi Doldu",
    //   flex: 1,
    //   renderCell: (params) => (params.value ? "Evet" : "Hayır"),
    // },
    // {
    //   field: 'depleted',
    //   headerName: "Tüketildi",
    //   flex: 1,
    //   renderCell: (params) => (params.value ? "Evet" : "Hayır"),
    // },
    {
        field: 'valid_from',
        headerName: "Başlangıç Tarihi",
        flex: 1,
        renderCell: (params) => {
            if (!params?.value) return '';
            return dayjs(params.value).format('DD-MM-YYYY HH:mm');
        }
    },
    {
        field: 'valid_until',
        headerName: "Bitiş Tarihi",
        flex: 1,
        renderCell: (params) => {
            if (!params?.value) return '';
            return dayjs(params.value).format('DD-MM-YYYY HH:mm');
        }
    },
    {
        field: 'created_at',
        headerName: "Oluşturulma Tarihi",
        flex: 1,
        renderCell: (params) => {
            const raw =
                params.row?.created_at ??
                null;

            if (!raw) return '';
            return dayjs.utc(raw).local().format('DD-MM-YYYY HH:mm');
        },
    },
    { field: 'status', headerName: "Durum", flex: 1 },
];

export const assignBoostToUserListColumns = () => [
    // { field: 'assignment_id', headerName: "Assignment ID", flex: 1 },
    // { field: 'user_id', headerName: "User ID", flex: 1 },
    { field: 'email', headerName: "Email", flex: 2 },
    {
        field: 'tier_id', headerName: "Kullanıcı Kategorisi", flex: 1, renderCell: (params) => {
            const match = TIER_TYPES.find((admin) => admin.Code === params.value);
            return match ? match.ValueText1 : params.value;
        }
    },
    { field: 'meta_id', headerName: 'Meta ID', flex: 1 },

    {
        field: 'assigned',
        headerName: "Atanmış mı?",
        flex: 1,
        renderCell: (params) => (params.value ? "Evet" : "Hayır"),
    },
    {
        field: 'status',
        headerName: "Durum",
        flex: 1,
        renderCell: (params) => {
            const labelMap = {
                active: "Active",
                inactive: "Inactive"
            };
            return labelMap[params.value] || params.value;
        }
    }
];

export const weeklyBoostsColumns = () => [
    // { field: 'id', headerName: "Id", flex: 1 },
    { field: 'category_name', headerName: "Boost Kategorisi", flex: 1 },
    {
        field: 'tierQuantities',
        headerName: "Kategori Miktarları",
        flex: 2,
        renderCell: (params) => {
            const tiers = params.row.tiers;
            if (!tiers) return '-';
            const order = ['basic', 'standard', 'advanced', 'elite'];
            const labelMap = { basic: 'Basic', standard: 'Standard', advanced: 'Advanced', elite: 'Elite' };
            const colorMap = { basic: '#e3f2fd', standard: '#e8f5e9', advanced: '#fff3e0', elite: '#f3e5f5' };
            const items = order.filter((name) => tiers[name]?.quantity !== undefined);
            if (items.length === 0) return '';
            return (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 0.5, width: '100%' }}>
                    {items.map((name) => (
                        <Chip
                            key={name}
                            size="small"
                            label={`${labelMap[name]}: ${tiers[name].quantity}`}
                            sx={{ backgroundColor: colorMap[name], borderColor: '#ddd' }}
                            variant="outlined"
                        />
                    ))}
                </Box>
            );
        }
    },
    {
        field: 'perUseCaps',
        headerName: "Kategori Değerleri",
        flex: 2,
        renderCell: (params) => {
            const tiers = params.row.tiers;
            if (!tiers) return '-';
            const order = ['basic', 'standard', 'advanced', 'elite'];
            const labelMap = { basic: 'Basic', standard: 'Standard', advanced: 'Advanced', elite: 'Elite' };
            const colorMap = { basic: '#e3f2fd', standard: '#e8f5e9', advanced: '#fff3e0', elite: '#f3e5f5' };
            const items = order.filter((name) => tiers[name]?.value !== undefined);
            if (items.length === 0) return '';
            return (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 0.5, width: '100%' }}>
                    {items.map((name) => (
                        <Chip
                            key={name}
                            size="small"
                            label={`${labelMap[name]}: ${tiers[name].value}`}
                            sx={{ backgroundColor: colorMap[name], borderColor: '#ddd' }}
                            variant="outlined"
                        />
                    ))}
                </Box>
            );
        }
    },
    { field: 'state', headerName: "Durum", flex: 1 }
];

export const specialOfferBoostsColumns = () => [
    { field: 'category_name', headerName: "Boost Kategorisi", flex: 1 },
    {
        field: 'tierQuantities',
        headerName: "Kategori Miktarları",
        flex: 2,
        renderCell: (params) => {
            const tiers = params.row.tiers;
            if (!tiers) return '-';
            const order = ['special'];
            const labelMap = { special: 'Special' };
            const colorMap = { special: '#e1f5fe' };
            const items = order.filter((name) => tiers[name]?.quantity !== undefined);
            if (items.length === 0) return '';
            return (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 0.5, width: '100%' }}>
                    {items.map((name) => (
                        <Chip
                            key={name}
                            size="small"
                            label={`${labelMap[name]}: ${tiers[name].quantity}`}
                            sx={{ backgroundColor: colorMap[name], borderColor: '#ddd' }}
                            variant="outlined"
                        />
                    ))}
                </Box>
            );
        }
    },
    {
        field: 'perUseCaps',
        headerName: "Kategori Değerleri",
        flex: 2,
        renderCell: (params) => {
            const tiers = params.row.tiers;
            if (!tiers) return '-';
            const order = ['special'];
            const labelMap = { special: 'Special' };
            const colorMap = { special: '#e1f5fe' };
            const items = order.filter((name) => tiers[name]?.value !== undefined);
            if (items.length === 0) return '';
            return (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 0.5, width: '100%' }}>
                    {items.map((name) => (
                        <Chip
                            key={name}
                            size="small"
                            label={`${labelMap[name]}: ${tiers[name].value}`}
                            sx={{ backgroundColor: colorMap[name], borderColor: '#ddd' }}
                            variant="outlined"
                        />
                    ))}
                </Box>
            );
        }
    },
    {
        field: 'valid_from', headerName: "Başlangıç Tarihi", flex: 1,
        renderCell: (params) => {
            if (!params?.value) return '';
            return dayjs(params.value).format('DD-MM-YYYY HH:mm');
        }
    },
    {
        field: 'valid_until', headerName: "Bitiş Tarihi", flex: 1,
        renderCell: (params) => {
            if (!params?.value) return '';
            return dayjs(params.value).format('DD-MM-YYYY HH:mm');
        }
    },
    { field: 'state', headerName: "Durum", flex: 1 }
];

export const periodOfferBoostsColumns = () => [
    { field: 'category_name', headerName: "Boost Kategorisi", flex: 1 },
    {
        field: 'tierQuantities',
        headerName: "Kategori Miktarları",
        flex: 2,
        renderCell: (params) => {
            const tiers = params.row.tiers;
            if (!tiers) return '-';
            const order = ['basic', 'standard', 'advanced', 'elite'];
            const labelMap = { basic: 'Basic', standard: 'Standard', advanced: 'Advanced', elite: 'Elite' };
            const colorMap = { basic: '#e3f2fd', standard: '#e8f5e9', advanced: '#fff3e0', elite: '#f3e5f5' };
            const items = order.filter((name) => tiers[name]?.quantity !== undefined);
            if (items.length === 0) return '';
            return (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 0.5, width: '100%' }}>
                    {items.map((name) => (
                        <Chip
                            key={name}
                            size="small"
                            label={`${labelMap[name]}: ${tiers[name].quantity}`}
                            sx={{ backgroundColor: colorMap[name], borderColor: '#ddd' }}
                            variant="outlined"
                        />
                    ))}
                </Box>
            );
        }
    },
    {
        field: 'perUseCaps',
        headerName: "Kategori Değerleri",
        flex: 2,
        renderCell: (params) => {
            const tiers = params.row.tiers;
            if (!tiers) return '-';
            const order = ['basic', 'standard', 'advanced', 'elite'];
            const labelMap = { basic: 'Basic', standard: 'Standard', advanced: 'Advanced', elite: 'Elite' };
            const colorMap = { basic: '#e3f2fd', standard: '#e8f5e9', advanced: '#fff3e0', elite: '#f3e5f5' };
            const items = order.filter((name) => tiers[name]?.value !== undefined);
            if (items.length === 0) return '';
            return (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 0.5, width: '100%' }}>
                    {items.map((name) => (
                        <Chip
                            key={name}
                            size="small"
                            label={`${labelMap[name]}: ${tiers[name].value}`}
                            sx={{ backgroundColor: colorMap[name], borderColor: '#ddd' }}
                            variant="outlined"
                        />
                    ))}
                </Box>
            );
        }
    },
    {
        field: 'valid_from', headerName: "Başlangıç Tarihi", flex: 1,
        renderCell: (params) => {
            if (!params?.value) return '';
            return dayjs(params.value).format('DD-MM-YYYY HH:mm');
        }
    },
    {
        field: 'valid_until', headerName: "Bitiş Tarihi", flex: 1,
        renderCell: (params) => {
            if (!params?.value) return '';
            return dayjs(params.value).format('DD-MM-YYYY HH:mm');
        }
    },
    { field: 'state', headerName: "Durum", flex: 1 }
];
